var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"sticky-base-header",attrs:{"base-title":"Master Klinik"}}),_c('KlinikScreen',{attrs:{"methodObject":_vm.methodObject,"filterList":_vm.filterList,"buttonMethod":_vm.buttonMethod,"isFetching":_vm.isFetching,"permissionObject":_vm.permissionObject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }